import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AgGridAngular } from 'ag-grid-angular';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-account-list',
  templateUrl: './account-list.component.html',
  styleUrls: ['./account-list.component.css']
})
export class AccountListComponent implements OnInit {
  @ViewChild('agGrid',{static:false}) agGrid: AgGridAngular;
  accountListcolumnDefs = [
    {headerName: 'FINT ID', field: 'finterstal_id', resizable: true, sortable: true, filter: true, checkboxSelection: true},
    {headerName: 'Bank Name', field: 'bank_deatils.bank_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Protfolio Name', field: 'portfolio_deatils.portfolio_type', resizable: true, sortable: true, filter: true},
    {headerName: 'Customer Name', field: 'customer_name', resizable: true, sortable: true, filter: true},
    {headerName: 'Passport Number', field: 'passport_no', resizable: true, sortable: true, filter: true},
    {headerName: 'Account Number', field: 'acc_no', resizable: true, sortable: true, filter: true},
    {headerName: 'total_out_standing', field: 'total_out_standing', resizable: true, sortable: true, filter: true},
    {headerName: 'Allocation Status', field: 'allocation_status', resizable: true, sortable: true, filter: true},
    {headerName: 'Status', field: 'status', resizable: true, sortable: true, filter: true},

  ];
  accountList = [];
  allocations:any;
  actives:any;
  loading: boolean;
  userFilter: any = { Allocated_status: '', status:'' };
  editmode: boolean;
  new_passport_number:any;
  old_passport_number:any;
  account_status: any;
  editmodes: boolean;
  passport_no: any;
  acc_no: any;
  count: number;
  original_portfolio_list: any;
  origianl_bank_list: any;
  bank_id:any;
  porfolio_id:any;
  nO_DATA: boolean;
  Myloading: boolean;
  finterstal_id: string;
  finterstal_id_list: any[] = [];
  filteredFinterstalIdList: any[] = [];
  old_total_out_standing: any;
  new_total_out_standing: null;
  account_statuss: any;
  finterstal_idForm: any;

  constructor(private _api:ApiService, @Inject(SESSION_STORAGE) private storage: StorageService,private formBuilder:FormBuilder) {
    this.finterstal_idForm = this.formBuilder.group({
      finterstal_id:['',Validators.required],
  });
}
  ngOnInit(): void {
    this.loading = false;
    this.count = 0;
    this.portfolio_list_get();
    this.bank_list_get();
    this.finterstal_id_get()
    this.nO_DATA = true;
  }

//   filterFinterstalIdList(searchText: string) {
//     // Filter the finterstal_id_list based on the searchText
//     if (searchText.length === 0) {
//       this.filteredFinterstalIdList = [];
//     } else {
//       this.filteredFinterstalIdList = this.finterstal_id_list.filter(item =>
//         item.finterstal_id.toLowerCase().includes(searchText.toLowerCase())
//       );
//     }
//   }

//   fetchuser_1(){
//      let a = {
//        client_id : this.getFromLocal("Client_ID"),
//        bank_id : this.bank_id
//      }
//      this._api.portfolio_type_list_bank_id(a).subscribe(
//        (response: any) => {
//          this.original_portfolio_list = [];
//          this.original_portfolio_list = response.Data;
//          }
//      );
//    }

//   portfolio_list_get() {
//     let a = {
//       client_id : this.getFromLocal("Client_ID")
//     }
//     this._api.portfolio_type_list(a).subscribe(
//       (response: any) => {
//         this.original_portfolio_list = response.Data;
//         // let list = response.Data.reverse();
//         // for (let i = 0; i < list.length; i++) {
//         //   let obj = { "y": list[i].portfolio_type};
//         //   this.portfolio_list.push(obj);
//         // }
//         // this.booleans = true;
//       }
//     );
//   }
//   finterstal_id_get() {
//     this._api.finterstal_id_list().subscribe(
//       (response: any) => {
//         this. finterstal_id_list = response.Data;
//         // let list = response.Data.reverse();
//         // for (let i = 0; i < list.length; i++) {
//         //   let obj = { "y": list[i].portfolio_type};
//         //   this.portfolio_list.push(obj);
//         // }
//         // this.booleans = true;
//       }
//     );
//   }

//   getFromLocal(key): any {
//     return this.storage.get(key);
//   }


// bank_list_get() {
//     let a = {
//       client_id : this.getFromLocal("Client_ID")
//     }
//     this._api.fetch_bank_list_by_client_id(a).subscribe(
//       (response: any) => {
//         this.origianl_bank_list = response.Data;
//         // let list = response.Data.reverse();
//         // for (let i = 0; i < list.length; i++) {
//         //   let obj = { "y": list[i].portfolio_type};
//         //   this.portfolio_list.push(obj);
//         // }
//         // this.booleans = true;
//       }
//     );
//   }

//   getactives(event){
//     this.userFilter.status = event.target.value;
//   }

//   getallocations(event){
//         this.userFilter.Allocated_status = this.allocations;
//   }

//   getINC(){
//     // this.count = this.count + 500;
//     this.Myloading = true;
//     this.nO_DATA = true;
//     console.log("this.finterstal_id = " + this.finterstal_id);
//     this._api.getallocationList(this.finterstal_id).subscribe(data =>{
//       if (data['Code'] == 200) {
//         this.accountList = data['Data'];
//         console.log(" this.accountList", this.accountList);
//         this.accountList.forEach(element => {
//           let name = JSON.parse(element.customer_details);
//           element.customer_name = name[0].Customer_Name || '';
//           // element.cif = name[0].cif || '';
//           element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : name[0].total_out_standing;
//           element.agent_name = name[0].AGENT;
//         });

//         this.loading = true;
//         this.nO_DATA = false;
//         this.Myloading = false;
//       } else {
//         this.accountList = [];
//         this.loading = true;
//         this.nO_DATA = true;
//         this.Myloading = false;
//       }
//     });
//   }

//   edit(){
//     const selectedNodes = this.agGrid.api.getSelectedNodes();
//     console.log("selectedNodes",selectedNodes);

//     const selectedData = selectedNodes.map(node => node.data );
//     if (selectedData.length == 1) {
//       this.editmode = true;
//       this.old_total_out_standing = selectedData[0].total_out_standing;
//       this.passport_no = selectedData[0].passport_no;
//       this.acc_no = selectedData[0].acc_no;
//       this.porfolio_id = selectedData[0].porfolio_id;
//       this.bank_id = selectedData[0].bank_id;
//       this.finterstal_id = selectedData[0].finterstal_id;
//       // console.log(this.old_total_out_standing);

//     } else {
//       this.editmode = false;
//     }

//   }

//   edits(){
//     const selectedNodes = this.agGrid.api.getSelectedNodes();
//     const selectedData = selectedNodes.map(node => node.data );
//     if (selectedData.length == 1) {
//       this.editmodes = true;
//       this.account_status = selectedData[0].status;
//       this.passport_no = selectedData[0].passport_no;
//       this.acc_no = selectedData[0].acc_no;
//       this.porfolio_id = selectedData[0].porfolio_id;
//       this.bank_id = selectedData[0].bank_id;

//     } else {
//       this.editmodes = false;
//     }
//   }

//   update() {
//     if (this.old_total_out_standing != null && this.new_total_out_standing != null) {
//       const dataFormat = {
//         total_out_standing: this.new_total_out_standing,
//         passport_no: this.passport_no,
//         acc_no: this.acc_no,
//         porfolio_id: this.porfolio_id,
//         bank_id: this.bank_id,
//         finterstal_id:this.finterstal_id
//       };
//       this._api.update_tos(dataFormat).subscribe((data:any) => {
//         if (data['Code'] == 200) {
//           alert("Updated");
//         } else {
//           alert("Error");
//         }
//         return; // Add this return statement to prevent further execution
//       });
//     } else {
//       alert("Please Fill Old and New tos");
//     }
//   }


//   updates(){
//     if (this.account_status != null) {
//       const dataFormat = {
//         status: this.account_status,
//         passport_no:this.passport_no,
//         acc_no:this.acc_no,
//         porfolio_id : this.porfolio_id,
//         bank_id : this.bank_id,
//         finterstal_id:this.finterstal_id
//       }
//       this._api.update_account_status(dataFormat).subscribe(data=>{
//         if (data['Code']==200) {
//           alert("Updated");
//           this.getINC();
//         } else {
//           alert("Error");
//         }
//       });
//     } else {
//       alert("Please Select Active / Inactive Status")
//     }
//   }


//   cancel(){
//     this.editmode = false;
//     this.editmodes = false;
//   }


fetchuser_1(){
  let a = {
    client_id : this.getFromLocal("Client_ID"),
    bank_id : this.bank_id
  }
  this._api.portfolio_type_list_bank_id(a).subscribe(
    (response: any) => {
      this.original_portfolio_list = [];
      this.original_portfolio_list = response.Data;
      }
  );
}

portfolio_list_get() {
 let a = {
   client_id : this.getFromLocal("Client_ID")
 }
 this._api.portfolio_type_list(a).subscribe(
   (response: any) => {
     this.original_portfolio_list = response.Data;
     // let list = response.Data.reverse();
     // for (let i = 0; i < list.length; i++) {
     //   let obj = { "y": list[i].portfolio_type};
     //   this.portfolio_list.push(obj);
     // }
     // this.booleans = true;
   }
 );
}

filterFinterstalIdList(searchText: string) {
 // Filter the finterstal_id_list based on the searchText
 if (searchText.length === 0) {
   this.filteredFinterstalIdList = [];
 } else {
   this.filteredFinterstalIdList = this.finterstal_id_list.filter(item =>
     item.toLowerCase().includes(searchText.toLowerCase())
   );
 }
}
finterstal_id_get() {
 let a = {
   client_id : this.getFromLocal("Client_ID"),
   bank_id : this.bank_id
 }
 console.log(a);

 this._api.finterstal_id_list(a).subscribe(
   (response: any) => {
     this.finterstal_id_list = response.Data;
     console.log(" this.finterstal_id_list", this.finterstal_id_list);

     // let list = response.Data.reverse();
     // for (let i = 0; i < list.length; i++) {
     //   let obj = { "y": list[i].portfolio_type};
     //   this.portfolio_list.push(obj);
     // }
     // this.booleans = true;
   }
 );
}
getFromLocal(key): any {
 return this.storage.get(key);
}


bank_list_get() {
 let a = {
   client_id : this.getFromLocal("Client_ID")
 }
 this._api.fetch_bank_list_by_client_id(a).subscribe(
   (response: any) => {
     this.origianl_bank_list = response.Data;

     // let list = response.Data.reverse();
     // for (let i = 0; i < list.length; i++) {
     //   let obj = { "y": list[i].portfolio_type};
     //   this.portfolio_list.push(obj);
     // }
     // this.booleans = true;
   }
 );
}

getactives(event){
 this.userFilter.status = event.target.value;
}

getallocations(event){
     this.userFilter.Allocated_status = this.allocations;
}

// getINC(){
//   this.count = this.count + 500;
//   this.Myloading = true;
//   this.nO_DATA = true;
//   console.log(this.count,this.bank_id,this.porfolio_id,this.actives);
//   this._api.getallocationList(this.count,this.bank_id,this.porfolio_id,this.actives).subscribe(data =>{
//     if (data['Code'] == 200) {
//       this.accountList = data['Data'];
//       this.loading = true;
//       this.nO_DATA = false;
//       this.Myloading = false;
//     } else {
//       this.accountList = [];
//       this.loading = true;
//       this.nO_DATA = true;
//       this.Myloading = false;
//     }
//   });
// }
getINC(){
 // this.count = this.count + 500;
 this.Myloading = true;
 this.nO_DATA = true;
 console.log("this.finterstal_id = " + this.finterstal_idForm);
 let data= this.finterstal_idForm;
 let data_id = data.value
 console.log("data_id",data_id);

 this._api.getallocationList(data_id).subscribe((data:any )=>{
   if (data) {
     this.accountList = data['Data'];
     console.log(" this.accountList", this.accountList);
     this.accountList.forEach(element => {
       let name = JSON.parse(element.customer_details);
       element.customer_name = name[0].Customer_Name || '';
       // element.cif = name[0].cif || '';
       element.total_out_standing = name && name[0][' total_out_standing '] ? name[0][' total_out_standing '] : name[0].total_out_standing;
       element.agent_name = name[0].AGENT;
     });

     this.loading = true;
     this.nO_DATA = false;
     this.Myloading = false;
   } else {
     this.accountList = [];
     this.loading = true;
     this.nO_DATA = true;
     this.Myloading = false;
   }
 });
}
// edit(){
//  const selectedNodes = this.agGrid.api.getSelectedNodes();
//  const selectedData = selectedNodes.map(node => node.data );
//  if (selectedData.length == 1) {
//    this.editmode = true;
//    this.old_passport_number = selectedData[0].passport_no;
//  } else {
//    this.editmode = false;
//  }

// }

edits(){
 const selectedNodes = this.agGrid.api.getSelectedNodes();
 const selectedData = selectedNodes.map(node => node.data );
 if (selectedData.length == 1) {
   this.editmodes = true;
   this.account_status = selectedData[0].status;
   this.passport_no = selectedData[0].passport_no;
   this.acc_no = selectedData[0].acc_no;
   this.porfolio_id = selectedData[0].porfolio_id;
   this.bank_id = selectedData[0].bank_id;

 } else {
   this.editmodes = false;
 }
}
edit(){
  const selectedNodes = this.agGrid.api.getSelectedNodes();
  console.log("selectedNodes",selectedNodes);

  const selectedData = selectedNodes.map(node => node.data );
  if (selectedData.length == 1) {
    this.editmode = true;
    this.old_total_out_standing = selectedData[0].total_out_standing;
    this.passport_no = selectedData[0].passport_no;
    this.acc_no = selectedData[0].acc_no;
    this.porfolio_id = selectedData[0].porfolio_id;
    this.bank_id = selectedData[0].bank_id;
    this.finterstal_id = selectedData[0].finterstal_id;
    // console.log(this.old_total_out_standing);

  } else {
    this.editmode = false;
  }

}
// update(){
//  if (this.old_passport_number != null && this.new_passport_number != null) {
//    const dataFormat = {
//      pre_passport_no: this.old_passport_number,
//      new_passport_no : this.new_passport_number
//    }
//    this._api.update_passport_number(dataFormat).subscribe(data=>{
//      if (data['Code']==200) {
//        alert("Updated");
//      } else {
//        alert("Error");
//      }
//    });
//  } else {
//    alert("Please Fill Old and New Passport Number")
//  }
// }


update() {
  if (this.old_total_out_standing != null && this.new_total_out_standing != null) {
    const dataFormat = {
      total_out_standing: this.new_total_out_standing,
      passport_no: this.passport_no,
      acc_no: this.acc_no,
      porfolio_id: this.porfolio_id,
      bank_id: this.bank_id,
      finterstal_id:this.finterstal_id
    };
    this._api.update_tos(dataFormat).subscribe((data:any) => {
      if (data['Code'] == 200) {
        alert("Updated");
        this.getINC();
      } else {
        alert("Error");
      }
      return; // Add this return statement to prevent further execution
    });
  } else {
    alert("Please Fill Old and New tos");
  }
}

updates(){
 const selectedNodes = this.agGrid.api.getSelectedNodes();
 const selectedData = selectedNodes.map(node => node.data );
 this.account_status = selectedData[0].status;
 this.passport_no = selectedData[0].passport_no;
 this.acc_no = selectedData[0].acc_no;
 this.porfolio_id = selectedData[0].porfolio_id;
 this.bank_id = selectedData[0].bank_id;
 this.finterstal_id = selectedData[0].finterstal_id;
 console.log("selectedData",selectedData);

 if (this.account_status != null) {
   const dataFormat = {
     status: this.account_statuss,
     passport_no:this.passport_no,
     acc_no:this.acc_no,
     porfolio_id : this.porfolio_id,
     bank_id : this.bank_id,
     finterstal_id:this.finterstal_id
   }
   console.log("dataFormat",dataFormat);
   this._api.update_account_status(dataFormat).subscribe(data=>{
     if (data['Code']==200) {
       alert("Updated");
       this.getINC();
     } else {
       alert("Error");
     }
   });
 } else {
   alert("Please Select Active / Inactive Status")
 }
}


cancel(){
 this.editmode = false;
 this.editmodes = false;
}

}
